<template>
  <app-layout title="CRMSync">
    <DxScrollView width="100%" height="100%" class="px-4">
      <!-- Add padding on both sides -->
      <BsOnBoardForm
        :routeDef="this.routeDef"
        :createDef="this.billingDef"
        :modelData="modelData"
        ref="onboardformRenderer"
      />
    </DxScrollView>

    <!-- <div class="flex justify-center mt-4">
        <DxButton
          :width="120"
          text="Sync"
          type="default"
          styling-mode="contained"
          @click="saveRecord($event)"
        />

        <DxButton
          :width="120"
          text="Process"
          type="danger"
          styling-mode="contained"
          
        />
      </div> -->

    <div class="flex justify-center mt-4 space-x-4">
      <!-- Add space-x-4 for equal spacing -->
      <DxButton
        :width="120"
        text="Sync"
        type="default"
        styling-mode="contained"
        @click="saveRecord($event)"
      />

      <DxButton
        :width="120"
        text="Process"
        type="danger"
        :disabled="!isSynced"
        styling-mode="contained"
        @click="continueProcess($event)"

      />
    </div>
  </app-layout>
</template>
  
  <script>
import AppLayout from "@/Layouts/AppLayout.vue";
import DxDateBox from "devextreme-vue/date-box";
import DxButton, { DxButtonTypes } from "devextreme-vue/button";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxScrollView } from "devextreme-vue/scroll-view";

export default {
  props: {
    productId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptionPriceId: String,
    accountId: String,
    billingDef: {
      type: Array,
      default: [],
    },
    addressDef: {
      type: Array,
      default: [],
    },
    ledgerData: Object,
  },

  components: {
    AppLayout,
    DxDateBox,
    DxButton,
    DxButtonTypes,
    BsOnBoardForm,
    DxScrollView,
  },
  data() {
    return {
      isSynced: false, // Initial state for sync
    };
  },
  methods: {
    saveRecord() {
      let recordData = this.$refs.onboardformRenderer.formData;
      // console.log("SYNC CRM CALLING", recordData);
      this.$inertia.post(route("strtsynccrm", recordData));
     // this.isSynced = true; // Enable Process button when Sync is clicked
    },
  },
  mounted() {},
};
</script>
  